module.exports = __webpack_public_path__ + "img/jiaoyibj.4b8a646f.png";